import { createSlice } from "@reduxjs/toolkit";
import { createMessageBuilder } from "./builder";

const initialState = {
  loading: false,
};

export const messageSlice = createSlice({
  name: "messageInfo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    createMessageBuilder(builder);

    builder.addCase("logout", () => ({
      ...initialState,
      loggedIn: false,
      user: null,
    }));
  },
});

// export const {} = messageSlice.actions;

export const selectMessageLoading = (state) => state.messageInfo.loading;

export default messageSlice.reducer;
